import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { SERVER_URL } from "../../api/url";
import axios from "axios";



// const fetchPosts = async (page, pageSize) => {
//   const response = await fetch("");
//   const data = await response.json();
//   return data;
// };

const BlogMain = () => {
  const navigate = useNavigate(); // Get the navigate function
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false)
  const options = { year: 'numeric', month: 'short' };
  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/blog`, {
        params: {
          
          page: currentPage,
          limit: 9,
        },
      });

      const fetchedBlogs = response.data?.data || [];
      setData(fetchedBlogs?.currentDatas)
   
     setTotalPages(fetchedBlogs.totalPages)
     
    } catch (err) {
      console.error(err.response);
      // Handle errors (could show a toast or error message)
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(()=>{
   
    fetchBlogs()
  },[currentPage])
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrev = () => {
    if (currentPage > 1) handlePageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) handlePageChange(currentPage + 1);
   
  };

  const handlePostClick = (post) => {
    navigate(`/blog/${post.title}`, { state: { post } }); // Navigate to the post detail page with state
  };
console.log(data)

  return (
    <div className="react-blog-page pb---40 pt---110">
      {
        !loading && (
          <div className="container blog-container pb---70">
       
        {data.length===0 ?(
          <div className="course-message">
        <p className="no-courses">There are no blogs now.</p>
      </div>
        ) :(
          <div className="blog-grid blog-card-container">
          {
            data.map((post, index) => {
              return (
                <div
                key={index}
                className="blog-card"
                onClick={() => handlePostClick(post)} // Trigger the navigate function on click
              >
                  <div className="blog-card">
                    <img crossOrigin="anonymous"
                      className="blog-card-img"
                      src={`https://back.yourfrenchteachers.com/${post.coverMobile}`} alt=""
                    />
                    <div className="blog-text">
                      <p>
                        Published on <span>{new Date(post.createdAt).toLocaleDateString('en-US', {
                          month: 'long',
                          day: 'numeric',
                          year: 'numeric'
                        })}</span>
                      </p>
                      <p className="blog-title">{post.displayTitle}</p>
                    </div>
                  </div>
                </div>
              );
            })
          }
           </div>
        )}
          
       
     {
      data.length!==0 && (
        <div className="pagination-btn-container">
        <button
          className="pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      )
     }
      </div>
        )
      }
    </div>
  );
};

export default BlogMain;
